import ApiService from '@/services/api.service';

const ContactService = {
    getAll(parameter) {
        const params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            PatientCode: parameter.PatientCode
        };
        const requestData = {
            method: 'get',
            url: '/PatientContacts/',
            headers: {},
            params: params
        };
        return ApiService.customRequest(requestData);
    },

    getByCode(Code) {
        return ApiService.get(`/PatientContacts/?PatientCode=${Code}`);
    },

    get(id) {
        return ApiService.get(`/PatientContacts/${id}`);
    },

    addContact(data) {
        return ApiService.post(`/PatientContacts`, data);
    },

    deleteContact(id) {
        return ApiService.delete(`/PatientContacts/${id}`);
    },
    update(RecordId, Contact) {
        return ApiService.put(`/PatientContacts/${RecordId}`, Contact);
    },

    getAllWithFiltes(parameter) {
        const params = {
            SearchCriteria: parameter.SearchCriteria,
            PageSize: parameter.PageSize,
            PageNumber: parameter.PageNumber,
            PatientCode: parameter.PatientCode,
            recNo: parameter.recNo,
            releaseOnFile: parameter.releaseOnFile,
            mayHavePhoneCalls: parameter.mayHavePhoneCalls,
            supervisedPhoneCalls: parameter.supervisedPhoneCalls,
            visitationPerm: parameter.visitationPerm,
            unsupVisitsOnGrounds: parameter.unsupVisitsOnGrounds,
            unsupVisitsOffGrounds: parameter.unsupVisitsOffGrounds,
            needProbApprForOffGrounds: parameter.needProbApprForOffGrounds,
            mayVisit: parameter.mayVisit,
            patientCodeList: parameter.PatientCodeList
        };
        return ApiService.getWithArray('/PatientContacts/withFilters/', params);
    },

    getPatientPortalAll(parameters) {
        return ApiService.getWithArray('/PatientContacts/PatientPortal/', parameters);
    },

    updateContactNotification(parameters) {
        return ApiService.put(`/PatientContacts/UpdateNotification`, parameters);
    }
};

export default ContactService;
